import * as E from 'fp-ts/Either';
import { useEffect, useState } from 'react';

import { useAuth } from '../auth/AuthContext';
import { enumerateOrgs } from '../api/apiKeys';

export const useAPIKeyOrgs = () => {
  const auth = useAuth();
  const [organisations, setOrganisations] = useState<string[] | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!auth?.token) {
      return;
    }

    enumerateOrgs(auth.token).then((result) =>
      E.isLeft(result)
        ? setError(
            result.left.helpMessage ??
              result.left.message ??
              'Failed to fetch organisations'
          )
        : setOrganisations(Array.isArray(result.right) ? result.right : [])
    );
  }, [auth?.token]);

  return { organisations, error };
};
